import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { JourneyLogoutComponent } from './journey/journey-logout/journey-logout.component';
import { ClienBaseComponent } from './journey/user-types/client-partner/client-base/client-base.component';
import { ClientEmailVerifiedComponent } from './journey/user-types/client-partner/client-email-verified/client-email-verified.component';
import { ClientRegistrationComponent } from './journey/user-types/client-partner/client-registration/client-registration.component';
import { EmployerBaseComponent } from './journey/user-types/employer/employer-base/employer-base.component';
import { EmployerEsignComponent } from './journey/user-types/employer/employer-esign/employer-esign.component';
import { ProviderBaseComponent } from './journey/user-types/provider/provider-base/provider-base.component';
import { ProviderEmailVerifiedComponent } from './journey/user-types/provider/provider-email-verified/provider-email-verified.component';
import { ProviderLoginComponent } from './journey/user-types/provider/provider-login/provider-login.component';
import { ProviderPasswordResetComponent } from './journey/user-types/provider/provider-password-reset/provider-password-reset.component';
import { ProviderProfileComponent } from './journey/user-types/provider/provider-profile/provider-profile.component';
import { ProviderRegistrationComponent } from './journey/user-types/provider/provider-registration/provider-registration.component';
import { ProviderUsernameForgotComponent } from './journey/user-types/provider/provider-username-forgot/provider-username-forgot';
import { InvalidRegistrationLinkComponent } from './shared/components/invalid-registration-link/invalid-registration-link.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { canActivate, canJourneyStart, canRegister, confirmEmail } from './shared/services/auth.service';


const routes: Routes = [
  { path: 'provider', title: 'Provider', component: ProviderBaseComponent, canActivate: [canActivate], data: {type: 'provider'},
    children: [
      {path: 'login', title : 'Provider Login', canActivate: [canJourneyStart],component: ProviderLoginComponent },
      {path: 'register',  title : 'Provider Registration', canActivate: [canJourneyStart,canRegister], data: {type: 'provider'}, component: ProviderRegistrationComponent },
      {path: 'confirm-email',  title : 'Provider Email Verification', canActivate:[confirmEmail], data: {type: 'provider'}, component: ProviderEmailVerifiedComponent },
      {path: 'password', component: ProviderPasswordResetComponent,canActivate: [canJourneyStart]},
      {path: 'username', component: ProviderUsernameForgotComponent,canActivate: [canJourneyStart] },
      {path: 'profile/:profileType', component: ProviderProfileComponent,canActivate: [canJourneyStart] },
      {path: 'logout',component: JourneyLogoutComponent },
      {path: 'invalidRegLink',component: InvalidRegistrationLinkComponent },
      {path: '', pathMatch: "full", redirectTo: "login" }
    ]
  },
    { path: 'client', title: 'Client Partner', component: ClienBaseComponent, canActivate: [canActivate], data: {type: 'client'},
    children: [
      {path: 'login', title : 'Client Login', canActivate: [canJourneyStart],component: ProviderLoginComponent },
      {path: 'register',  title : 'Client Registration', canActivate: [canJourneyStart,canRegister], data: {type: 'client'}, component: ClientRegistrationComponent },
      {path: 'confirm-email',  title : 'Client Email Verification', canActivate:[confirmEmail], data: {type: 'client'}, component: ClientEmailVerifiedComponent },
      {path: 'password', component: ProviderPasswordResetComponent,canActivate: [canJourneyStart]},
      {path: 'username', component: ProviderUsernameForgotComponent,canActivate: [canJourneyStart] },
      // {path: 'profile/:profileType', component: ProviderProfileComponent,canActivate: [canJourneyStart] },
      {path: 'logout',component: JourneyLogoutComponent },
      {path: 'invalidRegLink',component: InvalidRegistrationLinkComponent },
      {path: '', pathMatch: "full", redirectTo: "login" }
    ]
  },
  { path: 'employer', title: 'Employer', component: EmployerBaseComponent, canActivate: [canActivate], data: {type: 'employer'},
    children: [
      {path: 'login', title : 'Employer Login', canActivate: [canJourneyStart],component: ProviderLoginComponent },
      {path: 'register',  title : 'Employer Registration', canActivate: [canJourneyStart,canRegister], data: {type: 'employer'}, component: ClientRegistrationComponent },
      {path: 'confirm-email',  title : 'Employer Email Verification', canActivate:[confirmEmail], data: {type: 'employer'}, component: ClientEmailVerifiedComponent },
      {path: 'password', component: ProviderPasswordResetComponent,canActivate: [canJourneyStart]},
      {path: 'username', component: ProviderUsernameForgotComponent,canActivate: [canJourneyStart] },
      {path: 'profile/:profileType', component: ProviderProfileComponent,canActivate: [canJourneyStart] },
      {path: 'logout',component: JourneyLogoutComponent },
      {path: 'esign', component: EmployerEsignComponent },
      {path: 'invalidRegLink',component: InvalidRegistrationLinkComponent },
      {path: '', pathMatch: "full", redirectTo: "login" }
    ]
  },
  { path: 'broker', title: 'Broker', component: EmployerBaseComponent, canActivate: [canActivate], data: {type: 'broker'},
    children: [
      {path: 'login', title : 'Broker Login', canActivate: [canJourneyStart],component: ProviderLoginComponent },
      {path: 'register',  title : 'Broker Registration', canActivate: [canJourneyStart,canRegister], data: {type: 'broker'}, component: ClientRegistrationComponent },
      {path: 'confirm-email',  title : 'Broker Email Verification', canActivate:[confirmEmail], data: {type: 'broker'}, component: ClientEmailVerifiedComponent },
      {path: 'password', component: ProviderPasswordResetComponent,canActivate: [canJourneyStart]},
      {path: 'username', component: ProviderUsernameForgotComponent,canActivate: [canJourneyStart] },
      {path: 'profile/:profileType', component: ProviderProfileComponent,canActivate: [canJourneyStart] },
      {path: 'logout',component: JourneyLogoutComponent },
      {path: 'esign', component: EmployerEsignComponent },
      {path: 'invalidRegLink',component: InvalidRegistrationLinkComponent },
      {path: '', pathMatch: "full", redirectTo: "login" }
    ]
  },
  { path: 'unauthorized',component: PageNotFoundComponent },
  { path: '', pathMatch: "full", component: PageNotFoundComponent },
  { path: '**', component: PageNotFoundComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
